import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Select from 'react-select'
import {InfoDemandeImmatSelected, ModeleEditCentre} from '../../../components/Models'
import {editCentreForDemandeImmat} from '../../../components/requests'
import {toast} from 'react-toastify'

type TransfertCentreModalProps = {
  centres?: ModeleEditCentre[]
  centreSelected?: ModeleEditCentre
  onTransfert?: (ModeleEditCentre) => void
  onCentreChange?: (ModeleEditCentre) => void
  infoSelected?: InfoDemandeImmatSelected
  handleImmatInfo?: any
  selectedOption?: any
  setSelectedOption?: any
}

const TransfertCentreModal = (props: TransfertCentreModalProps) => {
  const {
    centres,
    centreSelected,
    infoSelected,
    onTransfert,
    onCentreChange,
    handleImmatInfo,
    selectedOption,
    setSelectedOption,
  } = props
  // const selectedOption = centres?.find((opt) => opt.label == centreSelected?.label)
  const [selected, setSelected] = useState<ModeleEditCentre | null>(selectedOption ?? null)

  const centreChange = (e) => {
    setSelectedOption(e)
    setSelected(e)
    if (onCentreChange) {
      onCentreChange(e)
    }
  }

  const transfert = () => {
    if (!infoSelected?.idDemande && onTransfert) {
      onTransfert(centreSelected)
    } else {
      if (selected?.value == null || selected.value === 0) return
      const idDemande = infoSelected?.idDemande
      const immat = infoSelected?.immat
      const idModele = infoSelected?.idModele
      const idVehicleHorsType = infoSelected?.idVehicleHorsType
      editCentreForDemandeImmat(idDemande, immat, idModele, idVehicleHorsType, selected?.value)
        .then((editDemandeImmatRequest) => {
          if (
            editDemandeImmatRequest?.status === 200 &&
            editDemandeImmatRequest.data &&
            handleImmatInfo
          ) {
            handleImmatInfo(editDemandeImmatRequest.data?.centre?.nom)
            toast.success('Centre modifié avec succès')
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_transfert'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Transfert de centre</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Select
              className='react-select-styled react-select-solid react-select-lg'
              classNamePrefix='react-select'
              options={centres}
              fieldName='u_centre'
              value={selectedOption}
              onChange={(e) => centreChange(e)}
              placeholder='Sélectionner centres'
            />
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
              Fermer
            </button>
            <button
              type='button'
              className='btn btn-primary'
              data-bs-dismiss='modal'
              onClick={transfert}
            >
              Transférer
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export {TransfertCentreModal}
